import { useQuery } from '@tanstack/react-query';
import type AgentApiAiRecommendationReferenceItemsIndex from '@/types/serializers/AgentApiAiRecommendationReferenceItemsIndex';

/** AI推薦の参照情報候補（候補者情報カテゴリ・面談ログ）を取得する */
export default function useFetchAiRecommendationReferenceItems(candidateProfileId: number | null) {
  return useQuery({
    queryKey: ['ai_recommendation_reference_items', candidateProfileId],
    enabled: candidateProfileId !== null,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<AgentApiAiRecommendationReferenceItemsIndex> => {
      const response = await fetch(
        `/agent/api/candidate_profiles/${candidateProfileId}/ai_recommendation_reference_items`
      );
      if (!response.ok) {
        throw new Error('参照情報の取得に失敗しました');
      }
      const data: AgentApiAiRecommendationReferenceItemsIndex = await response.json();
      return data;
    },
  });
}
